import React from 'react';
import { withRouter } from 'react-router-dom';
import dataModel  from '../../../../models/DataModel';
import BaseComponent from '../../../../baseClasses/BaseComponent';

import * as BuildOwnerPermissionsUtil from '../../../../helpers/permissions/BuildOwnerPermissionsUtil';

import LoadingDots from '../../../../components/LoadingDots';
import TaskCard from '../TaskCard';
import NewCard from '../../../../components/NewCard';
import CheckBox from '../../../../components/CheckBox';
import { task_root } from '../../../../dao/TasksDAO';

export class TaskSwimLanes extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedTask: null,
      displayAddCard: false,
    };
    this.columnNameToNumber = {
      'NotStarted': 1,
      'InProgress': 2,
      'UnderReview': 3,
      'Completed': 4,
    };
    this.draggableTasks = {};
    this.canBuildOwnerAssign = (
      BuildOwnerPermissionsUtil.isBuildOwnerInProject(props.selectedProject, props.currentUser) 
      && BuildOwnerPermissionsUtil.isBuildOwnerInVendorCompany(props.currentCompany, props.currentUser)
    );

    this.buildOwnerAccessible = this.buildOwnerAccessible.bind(this);
    this.filterAvailableTasksByColumn = this.filterAvailableTasksByColumn.bind(this);
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }
  
  componentDidUpdate(prevProps) {
    if (prevProps.myTasksNotStarted != this.props.myTasksNotStarted ||
      prevProps.myTasksInProgress != this.props.myTasksInProgress ||
      prevProps.myTasksUnderReview != this.props.myTasksUnderReview ||
      prevProps.myTasksCompleted != this.props.myTasksCompleted) {
      this.setState({ scrollInProgress: null });
      this.handleMergeTasks();
    }
    if (prevProps.quickAssignments != this.props.quickAssignments) {
      for (let columnName in this.columnNameToNumber) {
        if (columnName) {
          let selectedColumnName = `column${this.columnNameToNumber[columnName]}Checked`;
          this.setState({ [selectedColumnName]: false });
        }
      }
    }
  }

  /** CLICK HANDLERS */
  handleAddTask() {
    this.setState({ displayAddCard: true });
  }
  handleCancelAdd() {
    this.setState({ displayAddCard: false });
  }

  handleCreateTask(name, parent) {
    const { selectedProject } = this.props;
    if (parent) {
      let order =
        parent.tasks && parent.tasks.length > 0 ? parent.tasks.length + 1 : 1;
      const newTask = {
        name: name,
        project_id: selectedProject.id,
        build_id: parent.id,
        order: order,
        location_id: selectedProject && selectedProject.location ? selectedProject.location.id : null,
      };
      dataModel.tasksDAO.createTask(newTask, { recordDescriptor: task_root }).then(createdTask => {
        this.setState({ selectedTask: createdTask, displayAddCard: false });
        this.props.history.push('/projects/' + createdTask.project_id + '/build/' + createdTask.build_id + '/task/' + createdTask.id + '/edit');
      });
    }

  }

  handleTaskSelect(task, project, columnNumber) {
    const { quickAssignments, inProjectsTab } = this.props;
    if (quickAssignments && inProjectsTab) {
      this.handleBulkSelect(task, columnNumber);
    }
    else {
      // Route to task
      if (!this.state.selectedTask || (this.state.selectedTask.id != task.id)) {
        this.setState({ selectedTask: task });
      }
      if (inProjectsTab) {
        this.props.history.push(
          '/projects/' + task.project_id + '/build/' + task.build_id + '/task/' + task.id
        );
      }
      else {
        // Tasks tab routing
        if (task.project) {
          this.props.history.push(`/tasks/project/${task.project.id}/task/${task.id}`);
        } else if (task && task.project_id) {
          this.props.history.push({ pathname: `/tasks/project/${task.project_id}/task/${task.id}` });
        } else (
          this.props.history.push(`/tasks/project/all/task/${task.id}`)
        );
      }
    }
  }

  handleBulkSelect(task, columnNumber) {
    const columnName = Object.keys(this.columnNameToNumber).find(key => this.columnNameToNumber[key] == columnNumber);
    const { selectedTaskIds } = this.props;

    if (this.props.selectedTaskIds && selectedTaskIds.has(task.id)){
      this.props.removeSelectedTask(task);
      this.setState({ ['column'+columnNumber+'Checked']: false });
    } else {   
      //in order to determine if the "select all" button is checked
      //see if there are any available tasks that are not the selected task   
      let availableTasks = this.filterAvailableTasksByColumn(columnName).filter(availableTask => availableTask.id != task.id);
      //since tasks that are already selected are technically available, also check the selectedTaskIds prop
      if (selectedTaskIds) {
        //if there are tasks that are also in the selectedTaskIds (meaning they are already selected), take them out of the available tasks
        availableTasks = availableTasks.filter(availableTask => !selectedTaskIds.has(availableTask.id));
      }

      //if there are no available tasks left (or tasks that have not been selected and can be selected)
      if (!availableTasks.length) {
        //set the "select all" button to be checked
        this.setState({ ['column'+columnNumber+'Checked']: true });
      }

      this.props.addSelectedTask(task);
    }
  }

  filterAvailableTasksByColumn(columnName) {
    const taskCollection = this.props['myTasks'+columnName];
    //check if the current user is the proper build owner
    if (this.canBuildOwnerAssign && !this.props.currentUser.super_admin) {
      let reducedTasks = this.filterAvailableBuildOwnerTasksByColumn(taskCollection);
      return reducedTasks ? reducedTasks : [];
    }

    let reducedTasks = taskCollection.tasks.reduce((accu, task) => {
      const utas = task.user_task_assignments
        ? task.user_task_assignments.filter(uta => {
          return (
              this.props.selectedUser &&
              uta && uta.user_id &&
              uta.user_id == this.props.selectedUser.id
            );
        })
        : [];
      if (utas.length > 0) {
        return accu;
      }
      accu.push(task);
      return accu;
    }, []);
    return reducedTasks ? reducedTasks : [];
  }

  filterAvailableBuildOwnerTasksByColumn(taskCollection) {
    return taskCollection.tasks ? taskCollection.tasks.reduce((accu, task) => {
      if (this.buildOwnerAccessible(task)) {
        accu.push(task);
      }
      return accu;
    }, []) : [];
  }

  selectAllTasksInColumn(columnName) {
    const selectedColumnName = `column${this.columnNameToNumber[columnName]}Checked`;
    // TODO: this logic is duplicated in handleCreateTaskCards - can probably maintain a list under 'this'
    let availableTasks = this.filterAvailableTasksByColumn(columnName);

    availableTasks.forEach(task => {
      if (!this.state[selectedColumnName]) {
        if (!this.props.selectedTaskIds.has(task.id)) {
          this.props.addSelectedTask(task);
        }
      } else {
        this.props.removeSelectedTask(task);
      }
    });

    this.setState({
      [selectedColumnName]: !this.state[selectedColumnName],
    });
  }

  /** DRAG/DROP FUNCTIONS */
    // TODO: look into 3rd party drag/drop to reduce this code footprint
  handleDragging(task, x, y) {
    // Start in one column, and stay in that column
    if (!this.dragX) {
      const rect = this.scrollColumn.getBoundingClientRect();
      this.dragObject = task;
      this.dragX = rect.left;
      this.dragTarget = this.handleFindDragTarget(y);
      this.handleCreateDragIndicator();
      if (this.dragTarget) {
        this.handlePositionDragIndicator();
      }
    } else {
      const newDragTarget = this.handleFindDragTarget(y);
      if (
        (newDragTarget && newDragTarget != this.dragTarget) ||
        this.dragBefore
      ) {
        this.dragTarget = newDragTarget;
        this.handlePositionDragIndicator();
      }
    }
    if (this.dragTarget) {
      const scrollerRect = this.scrollColumn.getBoundingClientRect();
      if (y + 20 + this.dragTarget.height > scrollerRect.bottom) {
        this.scrollColumn.scrollTop +=
          y + 20 + this.dragTarget.height - scrollerRect.bottom;
        this.handlePositionDragIndicator();
      } else if (y < scrollerRect.top) {
        this.scrollColumn.scrollTop -= Math.abs(y - scrollerRect.top);
        this.handlePositionDragIndicator();
      }
    }
  }

  handleFindDragTarget(y) {
    const dragObject = this.draggableTasks[this.dragObject.id];
    const containerRect = this.listColumn.getBoundingClientRect();
    const normalizeY = y - containerRect.top + 40;
    let firstInList = true;
    for (let task of this.orderedTasks) {
      if (task) {
        if (
          this.draggableTasks[task.id] &&
          this.draggableTasks[task.id].parent &&
          dragObject.parent &&
          this.draggableTasks[task.id].build_id == dragObject.build_id
        ) {
          const element = document.getElementById(task.id);
          if (element) {
            if (
              firstInList &&
              normalizeY < element.offsetTop &&
              normalizeY <= element.offsetTop + element.offsetHeight / 2
            ) {
              this.dragBefore = true;
              return {
                item: this.draggableTasks[task.id],
                y: element.offsetTop,
                x: element.offsetLeft,
                height: element.offsetHeight,
                width: element.offsetWidth,
              };
            } else if (
              normalizeY >= element.offsetTop &&
              normalizeY <= element.offsetTop + element.offsetHeight
            ) {
              this.dragBefore = false;
              return {
                item: this.draggableTasks[task.id],
                y: element.offsetTop,
                x: element.offsetLeft,
                height: element.offsetHeight,
                width: element.offsetWidth,
              };
            }
            firstInList = false;
          }
        }
      }
    }
  }

  handleCreateDragIndicator() {
    this.lineElement = document.createElement('div');
    this.lineElement.style.width = '202px';
    this.lineElement.style.height = '6px';
    this.lineElement.style.backgroundColor = '#a7a7a7';
    this.lineElement.style.position = 'absolute';
    this.lineElement.style.zIndex = 999;
    this.listColumn.appendChild(this.lineElement);
  }

  handlePositionDragIndicator() {
    if (this.dragTarget) {
      let top =
        this.dragTarget.y +
        this.dragTarget.height +
        2 -
        this.scrollColumn.scrollTop;

      if (this.dragBefore) {
        top = this.dragTarget.y - 8;
      }

      this.lineElement.style.top = top + 'px';
      this.lineElement.style.left = this.dragTarget.x + 'px';
    }
  }

  async handleMergeTasks() {
    this.allTasks = [];

    if (this.props.myTasksNotStarted) {
      for (let task of this.props.myTasksNotStarted.tasks) {
        this.allTasks.push(task);
      }
    }
    if (this.props.myTasksInProgress) {
      for (let task of this.props.myTasksInProgress.tasks) {
        this.allTasks.push(task);
      }
    }
    if (this.props.myTasksUnderReview) {
      for (let task of this.props.myTasksUnderReview.tasks) {
        this.allTasks.push(task);
      }
    }
    if (this.props.myTasksCompleted) {
      for (let task of this.props.myTasksCompleted.tasks) {
        this.allTasks.push(task);
      }
    }
    this.allTasks.sort((t1, t2) => {
      return t1.order < t2.order ? -1 : t1.order > t2.order ? 1 : 0;
    });
  }

  handleDropping(orderedTask, x, y) {
    if (this.dragTarget) {
      let afterTask = this.dragBefore ? null : this.dragTarget.item;
      let reorderedTasks = {};

      // make sure there are no duplicate orders and they are all in the same build

      let filteredTasks = this.allTasks.filter(task => {
        return task.build_id == this.dragTarget.item.build_id;
      });

      let order = 1;
      for (let task of filteredTasks) {
        if (task.order != order) {
          task.order = order++;
          if (afterTask && afterTask.id == task.id) {
            afterTask = task;
          }
          else if (task.id == orderedTask.id) {
            orderedTask = task;
          }
          reorderedTasks[task.order] = task;
        }
        else {
          order++;
        }
      } 

      let oldOrder = orderedTask.order;
      let newOrder = !afterTask ? 1 : afterTask.order > oldOrder ? afterTask.order : afterTask.order + 1;

      let startOrder = oldOrder < newOrder ? oldOrder : newOrder;
      let endOrder = oldOrder > newOrder ? oldOrder : newOrder;
      let currentOrder = oldOrder < newOrder ? oldOrder : newOrder + 1;
      for (let task of filteredTasks) {
        let t = task;
        if (t.order >= startOrder && task.order <= endOrder && task.id != orderedTask.id) {
          task.order = currentOrder++;
          reorderedTasks[task.order] = task;
        }
      }

      orderedTask.order = newOrder;
      reorderedTasks[newOrder] = orderedTask;

      let reorderedArray = [];
      for (var key in reorderedTasks) {
        if (key) {
          let task = reorderedTasks[key];
          reorderedArray.push(task);
        } 
      }
      dataModel.tasksDAO.reorderTasks(reorderedArray, this.props.build);
      this.handleDragFinished();
    }
  }

  handleDragCancel() {
    this.handleDragFinished();
  }

  handleDragFinished() {
    this.listColumn.removeChild(this.lineElement);
    if (this.dragObject && this.dragObject.id) {
      const draggedTaskElement = document.getElementById(this.dragObject.id);
      if (draggedTaskElement) {
        draggedTaskElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        draggedTaskElement.focus();
      }
    }
    delete this.dragX;
    delete this.lineElement;
    delete this.dragTarget;
  }

  sortTasks(tasks) {
    // TODO: CLEAN THIS UP
    tasks.sort((t1, t2) => {
      if (t1.parent && t2.parent && t1.parent.id != t2.parent.id) {
        if (t1.parent.order && !t2.parent.order) {
          return -1;
        } else if (!t1.parent.order && t2.parent.order) {
          return 1;
        } else if (t1.parent.order && t2.parent.order) {
          if (t1.parent.order < t2.parent.order) {
            return -1;
          } else if (t1.parent.order > t2.parent.order) {
            return 1;
          } else {
            return 0;
          }
        } else if (t1.parent.id < t2.parent.id) {
          return -1;
        } else if (t1.parent.id > t2.parent.id) {
          return 1;
        } else return 0;
      } else if (t1.order && !t2.order) {
        return -1;
      } else if (!t1.order && t2.order) {
        return 1;
      } else if (t1.order && t2.order) {
        if (t1.order < t2.order) {
          return -1;
        } else if (t1.order > t2.order) {
          return 1;
        } else {
          return 0;
        }
      } else if (t1.id < t2.id) {
        return -1;
      } else if (t1.id > t2.id) {
        return 1;
      } else return 0;
    });
  }
  orderTasks(tasks, afterTask, insertedTask, orderedTasks) {
    let order = 1;
    if (!afterTask) {
      insertedTask.order = order;
      order++;
      orderedTasks.push(insertedTask);
      for (let i = 0; i < tasks.length; i++) {
        const copyTask = tasks[i];
        if (copyTask.id != insertedTask.id) {
          copyTask.order = order;
          orderedTasks.push(copyTask);
          order++;
        }
      }
    } else {
      for (let i = 0; i < tasks.length; i++) {
        const copyTask = tasks[i];
        if (copyTask.id != insertedTask.id) {
          copyTask.order = order++;
          orderedTasks.push(copyTask);
          if (copyTask.id == afterTask.id) {
            insertedTask.order = order++;
            orderedTasks.push(insertedTask);
          }
        }
      }
    }
  }

  /** (INFINITE) SCROLLING FUNCTIONS */
  handleSetupScroller(element, target) {
    if (!this.testScrollElements) {
      this.testScrollElements = {};
    }
    if (element && !this.testScrollElements[target]) {
      this.testScrollElements[target] = element;
      this['scroller_' + target] = element;
      element.addEventListener('scroll', this.handleScrolling);
    }
    if (element && target == 'myTasksNotStarted') {
      this.scrollColumn = element;
    }
  }

  handleScrolling(e) {
    if (!this.iAmScrolling) {
      this.iAmScrolling = true;
      const scrollerId = e.target.id;
      const listElement = this['list_' + scrollerId];
      const scrollerElement = this['scroller_' + scrollerId];
      const myTasks = this.props[scrollerId];
      if (listElement && scrollerElement && myTasks) {
        const listRect = listElement.getBoundingClientRect();
        const scrollRect = scrollerElement.getBoundingClientRect();
        if (!this.infiniteDone && listRect.bottom - 131 <= scrollRect.bottom &&
          myTasks.tasks.length < myTasks.totalTasks) {
          this.setState({ scrollInProgress: scrollerId });
          if(!(this.props.isFilterActive && this.props.allProjects)){
            this.props.getNextPage(scrollerId).then(() => {
              this.setState({ scrollInProgress: null });
              this.iAmScrolling = false;
            });
          } else {
            this.setState({ scrollInProgress: null });
            this.iAmScrolling = false;
          }
        }
        else{
          this.iAmScrolling = false;
        }
      }
      else {
        this.iAmScrolling = false;
      }
    }
  }

  buildOwnerAccessible(task) {
    const { 
      currentUser, 
      quickAssignments,
      selectedProject,
    } = this.props;

    if (task.status == 'pending_approval') {
      return false;
    }

    //if the user is already assigned to anything in that task, not eligible
    if (this.props.selectedUser && task.user_task_assignments.find(uta => uta.user.id == this.props.selectedUser.id)) {
      return false;
    }

    if (currentUser.super_admin){
      return true;
    }
    if (!task.build_owner_ids || !task.build_owner_ids.includes(currentUser.id)) {
      return false;
    }
    const taskAssignmentsForRole = task.user_task_assignments.filter(uta => quickAssignments[uta.assignment_type]).map(uta => uta.user);
    return BuildOwnerPermissionsUtil.canBuildOwnerAssign(taskAssignmentsForRole, selectedProject.company_id);
  }
 
  handleAddCopiedTask(newTask, originalTask) {
    this.copiedTask = newTask;
    this.props.handleAddCopiedTask(newTask, originalTask);
  }

  /** RENDER FUNCTIONS */
  handleCreateTaskCards(target) {
    const { 
      inProjectsTab, 
      selectedTaskIds, 
      quickAssignments, 
      build,
      selectedProject,
      allProjects,
    } = this.props;

    const columnNumber = this.columnNameToNumber[target.replace('myTasks', '')];
    if (target == 'myTasksNotStarted') {
      this.draggableTasks = {};
    }

    let tasksToOrder;
    if(this.props.isFilterActive && allProjects){
      const newTarget = target + 'Filtered';
      tasksToOrder = this.props[newTarget];
    } else {
      tasksToOrder = this.props[target].tasks;
    }

    const self = this;
    const taskCards = !tasksToOrder ? [] : tasksToOrder.map(task => {
      if (task) {
        let dragEnabled = false;
        // only not started in projects have drag/drop
        let cardSelectDisabled = false;

        if (quickAssignments) {
          
          if (
            target == 'myTasksCompleted' ||
            (target == 'myTasksUnderReview' && (quickAssignments['field_user'] || (quickAssignments['reviewer'] && task.status == 'pending_approval')))
          ) {
            cardSelectDisabled = true;
          } else if (self.canBuildOwnerAssign && !this.props.currentUser.super_admin) {
              //check to see if the BO can have access to that task
            cardSelectDisabled = !self.buildOwnerAccessible(task);
          }
        }
        else {
          if (inProjectsTab && target == 'myTasksNotStarted' && build.id != selectedProject.root_build_id) {
            dragEnabled = true;
            self.draggableTasks[task.id] = task;
            self.draggableTasks[task.id].parent = build;
          }
        }
        const selected = selectedTaskIds.has(task.id);
        const isTaskCopied = this.copiedTask && this.copiedTask.id == task.id ? true : false;
        return (
          <TaskCard
            inProjectsTab={this.props.inProjectsTab}
            id={task.id}
            key={task.id}
            filter={target}
            selected={selected}
            taskId={task.id}
            selectTask={(task, project) => self.handleTaskSelect(task, project, columnNumber)}
            quickAssignments={quickAssignments}
            selectDisabled={cardSelectDisabled}
            handleDragging={dragEnabled ? self.handleDragging : null}
            handleDropping={dragEnabled ? self.handleDropping : null}
            handleDragCancel={dragEnabled ? self.handleDragCancel : null}
            permissions={this.props.permissions}
            handleAddCopiedTask={this.handleAddCopiedTask}
            isTaskCopied={isTaskCopied}
            currentUser={this.props.currentUser}
            handleTaskDeleted={this.props.updateProject}
          />
        );
      }
      else {
        // no task found
        return null;
      }
    });
    if (inProjectsTab && !quickAssignments && self.state.displayAddCard && target == 'myTasksNotStarted') {
      const addCard = (
        <NewCard
          id={'addNewTaskCard'}
          key={'new-task-card'}
          connectorClass={null}
          handleCancel={self.handleCancelAdd}
          handleCreate={self.handleCreateTask}
          parent={self.props.build}
          type={'task'}
        />
      );
      taskCards.push(addCard);
    }

    if (target == 'myTasksNotStarted'){
      self.orderedTasks = tasksToOrder;
    }

    return (
      <div className="column-contents" id={target} ref={element => {
        self.handleSetupScroller(element, target);
        if (target == 'myTasksNotStarted') {
          self.scrollColumn = element;
        }
      }}
>
        <div className="column-inner-contents" id={'list_' + target} ref={element => {
          this['list_' + target] = element;
          if (target == 'myTasksNotStarted') {
            this.listColumn = element;
          }
        }}>
          {taskCards}
        </div>
      </div>
    );
  }

  createSelectAllComponent(columnName) {
    const { inProjectsTab, quickAssignments } = this.props;
    if (inProjectsTab && quickAssignments && this.filterAvailableTasksByColumn(columnName).length) {
      const columnNumber = this.columnNameToNumber[columnName];
      return ( 
        <div className="select-all">
          <CheckBox
            key={'column-'+columnNumber+'-checkbox'}
            toggleCheckBox={() => this.selectAllTasksInColumn(columnName)}
            small={true} inversed={true}
            checked={this.state['column'+columnNumber+'Checked']}
          />
          <div className="select-all-caption">Select All</div>
        </div>
      );
    }
    else return null;
  }

  render() {
    let notStartedTasks = null;
    if ((this.props.myTasksNotStarted && this.props.myTasksNotStarted.tasks) || (this.props.isFilterActive && this.props.allProjects)) {
      notStartedTasks = this.handleCreateTaskCards('myTasksNotStarted');
    }

    let inProgressTasks = null;
    if ((this.props.myTasksInProgress && this.props.myTasksInProgress.tasks) || (this.props.isFilterActive && this.props.allProjects)) {
      inProgressTasks = this.handleCreateTaskCards('myTasksInProgress');
    }

    let underReviewTasks = null;
    if ((this.props.myTasksUnderReview && this.props.myTasksUnderReview.tasks) || (this.props.isFilterActive && this.props.allProjects)) {
      underReviewTasks = this.handleCreateTaskCards('myTasksUnderReview');
    }

    let completeTasks = null;
    if ((this.props.myTasksCompleted && this.props.myTasksCompleted.tasks) || (this.props.isFilterActive && this.props.allProjects)) {
      completeTasks = this.handleCreateTaskCards('myTasksCompleted');
    }

    let addButton = null;
    if (
      this.props.inProjectsTab &&
      // Undefined during the sign-out render: USER_LOGOUT resets the whole store.
      this.props.permissions && this.props.permissions.canCreateTask &&

      !this.props.quickAssignments && 
      this.props.build && this.props.build.ancestry
    ) {
      addButton = (
        <div className="column-footer">
          <div className='add-button-container' onClick={this.handleAddTask}>
            <div className={'add-button'} />
            <div className="add-label">{this.textMap.createTask}</div>
          </div>
        </div>
      );
    }

    return <div className={'project-tasks-scroller' + (this.props.mapExpanded ? ' display-map' : '')} >
        <div className="project-tasks-body">
        <div className="tasks-column column-1">
            <div className="column-header">
              <div className="caption">Not Started</div>
            </div>
            {this.createSelectAllComponent('NotStarted')}
            {notStartedTasks}
            {addButton}
            {this.state.scrollInProgress == 'myTasksNotStarted' && <div className="loading-more-indicator">
                <LoadingDots />
              </div>}
          </div>

          <div className="tasks-column column-2">
            <div className="column-header">
              <div className="caption">In-Progress</div>
            </div>
            {this.createSelectAllComponent('InProgress')}
            {inProgressTasks}
            {this.state.scrollInProgress == 'myTaskInProgress' && <div className="loading-more-indicator">
              <LoadingDots />
              </div>}
          </div>

          <div className="tasks-column column-3">
            <div className="column-header">
              <div className="caption">Under Review</div>
            </div>
            {this.createSelectAllComponent('UnderReview')}
            {underReviewTasks}
          {this.state.scrollInProgress == 'myTasksUnderReview' && <div className="loading-more-indicator">
            <LoadingDots />
              </div>}
          </div>

          <div className="tasks-column  column-4">
            <div className="column-header">
              <div className="caption">Complete</div>
            </div>
            {completeTasks}
          {this.state.scrollInProgress == 'myTasksComplete' && <div className="loading-more-indicator">
            <LoadingDots />
              </div>}
          </div>
        </div>
      </div>;
  }
}

export default withRouter(TaskSwimLanes);



// WEBPACK FOOTER //
// ./src/containers/TasksContainer/TasksContainerTasks/TaskSwimLanes/index.js